import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { resendInvite } from './types';
import { requestResendInviteSuccess, requestResendInviteFailure } from './reducer';

const logger = new Logger('Saga:FundingReport');

export function* requestResendInviteSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const { reportId } = action;

  try {
    const response = yield call(
      authApiService.put,
      routerService.generate('api.resend_invite_funding_report', { reportId }),
    );

    action.promise && action.promise.resolve(response.data);
    yield put(requestResendInviteSuccess());
  } catch (error) {
    logger.error('Failed to resend email invite with the following error', error);
    action.promise && action.promise.reject(error);
    yield put(requestResendInviteFailure());
  }
}

export default function* resendInviteSaga() {
  return yield all([takeLatest(resendInvite.request, requestResendInviteSaga)]);
}
